var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attendee-form-wrap",attrs:{"id":"page-attendee-add"}},[_vm._m(0),_c('vx-card',[_c('div',{staticClass:"tabs-container px-6 pt-6",attrs:{"slot":"no-body"},slot:"no-body"},[_c('menu-edit',{attrs:{"data":_vm.menu_data}})],1)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-custome"},[_c('h3',[_vm._v("Add Menu")])])
}]

export { render, staticRenderFns }